confirmImportCtrl.$inject = [
  'importState',
  '$stateParams',
  '$scope',
  '$uibModal',
  'events',
  'domain',
  'domainInfo'
]

export default function confirmImportCtrl(
  importState,
  $stateParams,
  $scope,
  $modal,
  events,
  domain,
  domainInfo
) {
  this.domainUuid = $stateParams.domainUuid
  this.importUuid = $stateParams.importUuid
  this.domain = domain
  $scope.$emit(events.DOMAIN_SELECTED, domain)

  this.state = importState
  importState.setImportUuid(this.importUuid)
  importState.setAutorefreshInterval(3000)
  this.showLog = true

  this.resetDomain = function() {
    domainInfo.refreshUsers()
  }

  this.showUserChanges = function() {
    var s = $scope.$new()
    s.importUuid = this.importUuid
    $modal.open({
      size: 'lg',
      template:
        '<div class="modal-body">' +
        '<a class="close" ng-click="$close()">&times;</a>' +
        '<h4 class="modal-title">User Changes Made</h4><hr>' +
        '<div user-diff link-users="true" import-uuid="{{importUuid}}"></div>' +
        '</div>',
      scope: s
    })
  }

  this.showSchoolChanges = function() {
    var s = $scope.$new()
    s.importUuid = this.importUuid
    $modal.open({
      size: 'lg',
      template:
        '<div class="modal-body">' +
        '<a class="close" ng-click="$close()">&times;</a>' +
        '<h4 class="modal-title">Schools Involved</h4><hr>' +
        '<div school-diff import-uuid="{{importUuid}}"></div>' +
        '</div>',
      scope: s
    })
  }

  this.showLicenseChanges = function() {
    var s = $scope.$new()
    s.importUuid = this.importUuid
    $modal.open({
      size: 'lg',
      template:
        '<div class="modal-body">' +
        '<a class="close" ng-click="$close()">&times;</a>' +
        '<h4 class="modal-title">License Changes Made</h4><hr>' +
        '<div license-diff import-uuid="{{importUuid}}" edit-mode="false"></div>' +
        '</div>',
      scope: s
    })
  }
}
